<template>
  <div>
    <el-button type="primary" style="margin-bottom: 10px" @click="addrow">
      添加
    </el-button>
    <span style="color: #ff2f00;font-size: 12px;margin-left: 10px"> 注：赎期（大于2条）应按照大小顺序依次输入</span>
    <el-table
      :data="tableData"
      border
      style="width: 100%" max-height="300"
    >
      <el-table-column type="index" label="序号" width="50" />
      <el-table-column prop="date" label="赎期（天数）">
        <template slot-scope="scope">
          <el-input-number v-model="scope.row.day" :step="1" :min="minDay(scope.$index)" style="width: 100%"
                           :controls="false"
          />
        </template>
      </el-table-column>
      <el-table-column prop="date" label="百分比（%）">
        <template slot-scope="scope">
          <el-input-number v-model="scope.row.pre" :min="0" style="width: 100%" :controls="false" />
        </template>
      </el-table-column>
      <el-table-column prop="date" label="删除" width="80">
        <template slot-scope="scope">
          <el-button type="text" style="color: #ff2f00" @click="remove(scope.$index)">
            删除
          </el-button>
        </template>
      </el-table-column>
    </el-table>
    <div style="text-align: center">
      <el-button type="primary" style="margin-top: 10px" @click="submit">
        确定
      </el-button>
    </div>
  </div>
</template>
<script type="es6">
export default {
  data () {
    return {
      tableData: []
    };
  },
  model: {
    prop: 'valStr',
    event: 'change'
  },
  props: {
    valStr: {
      type: String,
      default: ''
    }
  },
  components: {},
  computed: {
    totalP () {
      let cont = 0;
      this.tableData.forEach(item => {
        cont += item.pre;
      });
      return cont;
    }
  },
  methods: {
    remove (index) {
      this.tableData.splice(index, 1);
    },
    addrow () {
      this.tableData.push({
        day: 0,
        pre: 0
      });
    },
    minDay (index) {
      if (index === 0) {
        return 0;
      } else {
        let day = this.tableData[index - 1].day + 1;
        return day;
      }
    },
    initdata () {
      if (this.valStr) {
        let realArray = [];
        if (this.valStr) {
          let mainAry = this.valStr.split('/');
          mainAry.forEach((item) => {
            let itemarray = item.split(',');
            realArray.push({
              day: Number(itemarray[0]),
              pre: Number(itemarray[1].replace(/%/, ''))
            });
          });
        }
        this.tableData = realArray;
      } else {
        this.tableData = [{
          day: 0,
          pre: 100
        }];
      }
    },
    submit () {
      let str = '';
      if (this.totalP !== 100) {
        this.$message.error('账期百分比之和应为100%');
        return;
      }
      let error = false;
      this.tableData.forEach((item, index) => {
        if (index > 0 && this.tableData[index - 1].day >= item.day) {
          this.$message.error(`账期${index + 1}的赎期天数，应大于账期${index}`);
          error = true;
          return;
        }
        if (item.pre > 0) {
          str += item.day + ',' + item.pre + '%/';
        }
      });
      if (error) {
        return;
      }
      if (str) {
        str = str.substr(0, str.length - 1);
      }
      this.$emit('change', str);
    }
  },
  mounted () {
    this.initdata();
  }
};
</script>
<style lang="less"></style>
